import { useQuery } from 'react-query';
import CountryService from '../../services/CountryService';

const LoadCurrencies = () => {
  return useQuery(
    'currencies',
    async () => {
      const response = await CountryService.getCurrencies();
      return response;
    },
    {
      staleTime: 300000, // 5 minutes
      cacheTime: 600000, // 10 minutes
      onError: (error) => {
        console.error('Failed to load currencies:', error);
      }
    }
  );
};

export default LoadCurrencies;
